import React from 'react'
import { useNavigate } from 'react-router-dom'
import ClientSupport from '../client/ClientSupport'
import { I } from '../shared/ns-icons'

/* Lets an admin see the live client Help Center (/client/help is role-gated, so
   they can't load it directly). Renders the real client page inside a preview
   frame with a sticky bar to switch back to the editor. Read-only — it reads the
   same /api/wiki data clients see. */
export default function AdminHelpPreview() {
  const navigate = useNavigate()
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: 'var(--bg-0)' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '11px 24px', background: 'var(--accent)', color: '#fff', flexShrink: 0, boxShadow: '0 2px 14px rgba(0,0,0,0.18)', zIndex: 10 }}>
        <span style={{ display: 'inline-flex', fontSize: 17 }}><I.eye /></span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13.5, fontWeight: 600 }}>Previewing the client Help Center</div>
          <div style={{ fontSize: 12, opacity: 0.85 }}>Exactly what your clients see at /client/help — read-only.</div>
        </div>
        <button className="btn btn-sm" onClick={() => navigate('/admin/help')} style={{ background: '#fff', color: 'var(--accent)', border: 'none', fontWeight: 600 }}>
          <I.chevron style={{ transform: 'rotate(180deg)' }} /> Back to editor
        </button>
      </div>
      <div className="page-scroll" style={{ flex: 1, minHeight: 0 }}>
        <ClientSupport />
      </div>
    </div>
  )
}
